import { render } from "./AddScanView.vue?vue&type=template&id=44963882"
import script from "./AddScanView.vue?vue&type=script&lang=js"
export * from "./AddScanView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__